import React from "react"
import Scrollspy from "react-scrollspy"
import { Navbar, Nav, Container } from "react-bootstrap"
import Scroller from './scroller'
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'

const Header = () => {
  const getImagenes = graphql`
  {
    marca:file(relativePath: {eq: "marca.png"}) {
      childImageSharp {
        fluid(maxWidth: 180) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    sii:file(relativePath: {eq: "reconocida_sii2.png"}) {
      childImageSharp {
        fluid(maxWidth: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    poweredby:file(relativePath: {eq: "poweredby.png"}) {
      childImageSharp {
        fluid(maxWidth: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    
  }`

  const data = useStaticQuery(getImagenes);
  const { marca, sii, poweredby } = data;

  return (
    <>
      <Navbar className="navbar navbar-expand-lg navbar-light fixed-top py-2" id="mainNav" expand="md"
        collapseOnSelect={true}>
        <Container>
          <button onClick={() => { window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }); }} className="marca">
            <Image fluid={marca.childImageSharp.fluid} />
          </button>
          <Navbar.Toggle aria-controls="navbarResponsive" />
          <Navbar.Collapse id="navbarResponsive">
            <Nav className="navbar-nav ml-auto my-2 my-lg-0">
              <Scrollspy className="navbar-nav"
                items={["sobre", "contacto"]}
                currentClassName="active" rootEl={"#mainNav"}>
                <li className="nav-item">
                  <Nav.Link className={"js-scroll-trigger"} href="#inicio" onClick={Scroller.handleAnchorScroll}>Inicio</Nav.Link>
                </li>
                <li className="nav-item">
                  <Nav.Link className={"js-scroll-trigger"} href="#sobre" onClick={Scroller.handleAnchorScroll}>Sobre Desarrollo a medida</Nav.Link>
                </li>

                <li className="nav-item">
                  <Nav.Link className={"js-scroll-trigger"} href="#contacto" onClick={Scroller.handleAnchorScroll}>Contacto</Nav.Link>
                </li>

                <li className="nav-item img-nav">
                  <a href="http://www.sii.cl/servicios_online/1039-emp_prov_fe-1184.html" alt="SII" className="">
                    <Image fluid={sii.childImageSharp.fluid} />
                  </a>
                </li>

                <li className="nav-item img-nav poweredby">
                  <a href="http://www.abstrahere.com" alt="Abstrahere" >
                    <Image fluid={poweredby.childImageSharp.fluid} />
                  </a>
                </li>
              </Scrollspy>
            </Nav>
          </Navbar.Collapse>
        </Container>

      </Navbar>
    </>
  );

}

export default Header
